<template>
  <div
    ref="player"
    :class="{[size]: size, 'dark': dark}"
    :style="artworkStyle"
    class="simplecast-player simplecast-player-legacy"
  >
    <Main
      :dark="dark"
      :size="size"
      :store="store"
    />
  </div>
</template>

<script>
import Main from './LegacyMain'
import Store from '../store'

export default {
  components: {
    Main
  },
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small'
    },
    id: {
      type: String,
      default: ''
    },
    timejump: {
      type: Number,
      default: 0
    }
  },
  data () {
    return { store: new Store() }
  },
  computed: {
    artworkStyle () {
      if (this.size !== 'large') return false

      let image = false

      if (this.pod && this.pod.image_url) image = this.pod.image_url
      if (this.epi && this.epi.image_url) image = this.epi.image_url
      if (!image) return image

      return {
        backgroundImage: `url(${image})`,
        backgroundPosition: '50%',
        backgroundSize: 'cover'
      }
    },
    epi () { return this.store.state.episode },
    pod () { return this.store.state.podcast }
  },
  created () {
    this.store.setCurrentTime(this.timejump)
    this.store.setIsDark(this.dark)
    this.store.setIsLegacy(true)

    if (this.id !== '') {
      this.store.getEpisode(this.id)
    } else {
      console.error('You did not set an episode ID (╯°□°)╯︵ ┻━┻')
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.simplecast-player-legacy {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 4px;
  overflow: hidden;
  position: relative;

  // Dark
  &.dark {
    background: #bbb;
    background: rgba(0, 0, 0, 0.45);

    &.medium {
      background: #4A4A4A;
    }
    &.large {

    }
    .main {
      .controls-mute {
        svg {
          fill: #fff;
        }
      }
      .current-time,
      .total-time {
        background: none;
        color: #fff;
      }
      .scrubber-waveform {
        .scrubber-time {
          background: #fff;
        }
      }
    }
  }

  // Small
  &.small {
   .main {
      padding: 7px 9px;

      .play-pause {
        border: none;
        margin-right: 9px;
      }
      > div {
        display: flex;

        > div {
          align-items: center;
          display: flex;
          width: 100%;
        }
      }
    }
  }

  // Medium
  &.medium {
    .main {
      display: flex;
      height: 70px;
      padding: 12px;

      > div {
        align-self: stretch;
        display: flex;
        flex-direction: column;
        width: 100%;

        > div {
          width: 100%;

          &.meta-info {
            h1 {
              font-size: 18px;
            }
            h2 {
              font-size: 12px;
              line-height: 15px;
              text-transform: uppercase;
            }
          }
          &:not(.meta-info) {
            align-items: center;
            display: flex;
            flex: 1;
            justify-content: center;
          }
        }
      }
      .current-time,
      .total-time {
        font-size: 11px;
      }
      .total-time {
        padding-right: 0;
      }
    }
  }

  // Large
  &.large {
    align-items: flex-end;
    display: flex;
    height: 330px;

    &:after {
      background: linear-gradient(to bottom, transparent 33%, rgba(0, 0, 0, 0.2) 54%, rgba(0, 0, 0, 0.75) 100%);
      content: "";
      display: block;
      height: 100%;
      position: absolute;
      width: 100%;
    }
    .main {
      align-items: flex-end;
      box-sizing: border-box;
      display: flex;
      flex: 1;
      height: 100%;
      padding: 20px;
      position: relative;
      z-index: 1;

      > div {
        width: 100%;

        > div {
          &.meta-info {
            margin-bottom: 15px;

            h2 {
              color: rgba(255, 255, 254, .8);
              font-size: 12px;
              text-transform: uppercase;
            }
          }
          &:not(.meta-info) {
            align-items: center;
            display: flex;
            flex: 1;
            justify-content: center;
          }
        }
        .current-time,
        .total-time {
          font-size: 0.86em;
        }
        .total-time {
          padding-right: 0;
        }
      }
      .itunes-url {
        background: none;
        border: none;
        padding: 0;
      }
      .scrubber-waveform {
        .scrubber-time {
          background: #6F6D70;
        }
        .scrubber-loader {
          background: rgba(0, 0, 0, .2);
        }
        .scrubber-bg {
          // background: rgba(0, 0, 0, .3);
          background: #D5D5D5;
        }
      }
    }
  }

  .main {
    align-items: center;

    .artwork {
      margin-right: 12px;
      max-width: 70px;
      width: 100%;
    }
    .controls-mute {
      height: 11px;
      width: 18px;
    }
    .controls-rewind {
      height: 12px;
      margin: 0;
      width: 12px;
    }
    .controls-speed {
      border: none;
      margin-left: 9px;
      padding: 0;
      width: 22px;
    }
    .current-time,
    .total-time {
      background: none;
      height: auto;
      margin: 0;
      padding: 0 10px;
      position: relative;
      text-align: center;
      top: 0;
      // width: 60px;
    }
    .scrubber-waveform {
      .current-time,
      .total-time {
        display: none;
      }
    }
    .itunes-url {
      background: #000;
      border: 1px solid #B1B3B6;
      color: #fff;
      text-decoration: none;
      position: absolute;
      display: block;
      top: 12px;
      right: 12px;
      padding: 0px 5px;
      border-radius: 2px;
      text-decoration: none;

      @include font-s-embed()

      font-size: 11px;
      line-height: 15px;

      svg {
        width: 134px;
      }
    }
    .play-pause {
      border: none;
      height: 18px;
      width: 18px;
    }
    .scrubber-waveform {
      &,
      & > div {
        align-items: center;
        display: flex;
        flex: 1;

        .scrubber-time,
        .scrubber-loader,
        .scrubber-bg {
          height: 6px;
          fill: rgba(0, 0, 0, 0);
        }
        .scrubber-time {
          background: #000;
        }
        .scrubber-loader {
          background: rgba(0, 0, 0, .1);
        }
        .scrubber-bg {
          background: rgba(0, 0, 0, .3);
        }
        }
      // #111

      // background: #111;

    }
  }
}
</style>
